export default "__VITE_ASSET__CTHIooCt__"